import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { useMe } from '@shared/providers/src/MeProvider'

import useConversationWithUser from './useConversationWithUser'

export const SUPPORT_REQUEST_PATH = '/app/messages/support-request'

export default function useSupportChat() {
  const me = useMe()
  const navigate = useNavigate()
  const startChat = useConversationWithUser()

  return useCallback(
    async (options = {}) => {
      const support = me.supportUser
      if (!support) return navigate(SUPPORT_REQUEST_PATH, { replace: options.replace })

      return startChat(support.id, { ...options, user: support, requestPath: SUPPORT_REQUEST_PATH })
    },
    [me.supportUser, navigate, startChat]
  )
}
